import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/Auth/AuthContext";
import Particles from "react-tsparticles";
import bgSvg from "../../assets/lines-and-dots-bg.svg";

interface LocationState {
  from?: {
    pathname: string;
  };
}

export function AuthForm() {
  const { isAuthenticated, login, signup, error, setError, isLoading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const location = useLocation();
  const from =
    (location.state as LocationState)?.from?.pathname || "/dashboard";

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh",     fontFamily: "'Poppins', sans-serif"    }}>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          backgroundColor: "#000",
          backgroundImage: `url(${bgSvg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />

      <div
        className="container-fluid min-vh-100 d-flex justify-content-center align-items-center"
        style={{
          position: "relative",
          zIndex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        }}
      >
        <div className="row justify-content-center w-100">
          <div className="col-12 col-md-7 col-lg-6 d-flex flex-column align-items-center gap-4">
            <div className="text-center">
              <h1
                style={{
                  letterSpacing: "5.76px",
                  color: "#78E01D",
                  fontWeight: "bold",
                }}
              >
                4Axon
              </h1>
              <p
                style={{
                  fontSize: "15px",
                  letterSpacing: "2.24px",
                  color: "#fff",
                  opacity: 0.8,
                }}
              >
                Estratégias e soluções para seu negócio.
              </p>
            </div>

            <div
              className="w-100 px-4 px-lg-5"
              style={{
                maxWidth: "500px",
                backgroundColor: "rgba(0, 0, 0, 0.85)",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
                padding: "30px",
                border: "1px solid #78E01D47",
                gap: "21px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {error && (
                <div className="alert alert-danger text-center" role="alert">
                  {error}
                </div>
              )}
              <form className="d-flex flex-column gap-3 w-100">
                <div className="form-group">
                  <label
                    htmlFor="email"
                    style={{ color: "#fff", fontWeight: "500" }}
                  >
                    E-mail
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Digite seu e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    style={{
                      backgroundColor: "#1a1a1a",
                      border: "1px solid #78E01D",
                      color: "#fff",
                    }}
                  />
                </div>
                <div className="form-group">
                  <label
                    htmlFor="password"
                    style={{ color: "#fff", fontWeight: "500" }}
                  >
                    Senha
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="Digite sua senha"
                     value={password}
                     onChange={(e) => setPassword(e.target.value)}
                    style={{
                      backgroundColor: "#1a1a1a",
                      border: "1px solid #78E01D",
                      color: "#fff",
                    }}
                  />
                </div>
              </form>

              <div className="text-center mt-4">
                <button
                  className="btn w-100 d-flex align-items-center justify-content-center gap-2"
                  style={{
                    backgroundColor: "#78E01D",
                    border: "none",
                    borderRadius: "50px",
                    padding: "12px 0",
                    fontWeight: "600",
                    color: "#000",
                  }}
                   onClick={() => login(email, password)}
                   disabled={isLoading}
                >
                  {isLoading ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      style={{ color: "#000" }}
                      role="status"
                    />
                  ) : (
                    <>FAZER LOGIN</>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
